import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M7.34 12c.8 0 1.58.43 1.9 1.17C9.69 14.25 10.76 15 12 15s2.31-.75 2.76-1.83c.32-.74 1.1-1.17 1.9-1.17H20c1.1 0 2 .9 2 2v5c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-5c0-1.1.9-2 2-2zM3.57 6.54c.38-.39 1.01-.39 1.39 0l2.15 2.17c.38.38.38 1.01 0 1.39l-.01.01c-.38.38-1.01.38-1.4 0-.62-.63-1.52-1.55-2.15-2.17-.39-.38-.39-1 0-1.39zm15.49.01c.38-.38 1.01-.38 1.39 0l.081.0917c.2968.3823.2698.9375-.081 1.2883-.63.63-1.53 1.54-2.15 2.17-.39.39-1.01.39-1.4 0l-.01-.01c-.39-.38-.39-1.01 0-1.39zM12.02 3c.54 0 .98.44.98.98v3.04c0 .54-.44.98-.99.98h-.03c-.54 0-.98-.44-.98-.99V3.98c0-.54.44-.98.99-.98z"
  }],
  circles: []
};
var UpcomingIcon = function UpcomingIcon(props) {
  return renderIcon(props, iconType);
};
export { UpcomingIcon };